import React from "react";
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory, {
//   PaginationProvider,
// } from "react-bootstrap-table2-paginator";
// import overlayFactory from "react-bootstrap-table2-overlay";
import Table from "../../../components/Table";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import {
  Spinner,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import "./styles.css";

export default ({ itens, pageProperties, notify, ...props }) => {
  const headerStyle = { fontSize: 9 };
  const { ExportCSVButton } = CSVExport;

  let columns = [
    {
      dataField: "empresa_nome", // estava "nome"
      text: "Nome da empresa",
      sort: true,
      headerStyle: { fontSize: 9, position: "sticky", left: 0, zIndex: 10 },
      style: { position: "sticky", left: 0, backgroundColor: "#fff" },
    },
    {
      dataField: "meta_geral",
      text: "Meta",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { fontSize: 9 },
      formatter: (cell) => {
        const valor = parseFloat(cell) || 0;
        return `R$ ${valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      csvFormatter: (cell) => {
        return parseFloat(cell) || 0;
      },
    },
    {
      dataField: "supermeta",
      text: "Supermeta",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { fontSize: 9 },
      formatter: (cell) => {
        const valor = parseFloat(cell) || 0;
        return `R$ ${valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      csvFormatter: (cell) => {
        return parseFloat(cell) || 0;
      },
    },

    {
      dataField: "vendas_geral",
      text: "Vendas",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { fontSize: 9 },
      formatter: (cell) => {
        const valor = parseFloat(cell) || 0;
        return `R$ ${valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      dataField: "percentual_meta",
      text: "% Meta",
      headerAlign: "center",
      sort: true,
      align: "center",
      formatter: (cell, row) => {
        const perc = parseFloat(cell) || 0;
        const isGood = perc >= 100;
        const colorClass = isGood ? "text-success" : "text-danger";
        const icon = isGood ? "fa-arrow-up" : "fa-arrow-down";
        return (
          <span>
            {perc.toFixed(2)}%
            <i
              className={`fas ${icon} ${colorClass} `}
              style={{ marginLeft: 4 }}
            />
          </span>
        );
      },
    },
    {
      dataField: "percentual_supermeta",
      text: "% Supermeta",
      headerAlign: "center",
      sort: true,
      align: "center",
      formatter: (cell, row) => {
        const perc = parseFloat(cell) || 0;
        const isGood = perc >= 100;
        const colorClass = isGood ? "text-success" : "text-danger";
        const icon = isGood ? "fa-arrow-up" : "fa-arrow-down";
        return (
          <span>
            {perc.toFixed(2)}%
            <i
              className={`fas ${icon} ${colorClass}`}
              style={{ marginLeft: 4 }}
            />
          </span>
        );
      },
    },
    {
      dataField: "projecao",
      text: "Projeção",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { fontSize: 9 },
      // se vier null/undefined, mostra "0"
      formatter: (cell) => {
        const valor = parseFloat(cell) || 0;
        return `R$ ${valor.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      csvFormatter: (cell) => {
        if (cell === null || cell === undefined || cell === "") {
          return "0";
        }
        return cell;
      },
    },

    {
      dataField: "percentual_projecao",
      text: "% Projeção",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: { fontSize: 9 },
      formatter: (_cell, row) => {
        const perc = parseFloat(row.percentual_projecao) || 0;
        return `${perc.toFixed(2)}%`;
      },
      csvFormatter: (cell) => {
        const perc = parseFloat(cell) || 0;
        return perc.toFixed(2);
      },
    },
  ];

  columns = columns.map((c) => ({
    ...c,
    csvText: c.dataField,
    footer: (columnData, index) => {
      if (c.dataField === "empresa_nome") return "Total";

      const camposPercentuais = [
        "percentual_meta",
        "percentual_supermeta",
        "percentual_projecao",
      ];
      if (camposPercentuais.includes(c.dataField)) return "";

      const total = columnData.reduce((acc, item) => {
        const valor = parseFloat(item);
        return acc + (isNaN(valor) ? 0 : valor);
      }, 0);

      const camposMonetarios = [
        "meta_geral",
        "supermeta",
        "vendas_geral",
        "projecao",
      ];
      if (camposMonetarios.includes(c.dataField)) {
        return `R$ ${total.toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }

      return total.toFixed(2);
    },

    footerStyle: (_, index) => {
      if (!!index) {
        return {
          textAlign: "center",
        };
      } else {
        return {
          position: "sticky",
          left: 0,
        };
      }
    },
  }));

  function contacatacaoHeader(column) {
    return (
      <>
        <div id={`column-${column.text}`}>
          <div dangerouslySetInnerHTML={{ __html: column.text }} />
          <span className="order-4 position-absolute right-0"></span>
        </div>
      </>
    );
  }

  return (
    <>
      {itens && pageProperties ? (
        // <Table
        //   columns={columns}
        //   data={itens}
        //   pageProperties={pageProperties}
        //   onTableChange={props.onTableChange}
        // />
        <ToolkitProvider
          data={itens}
          columns={columns}
          keyField={"empresa_id"}
          exportCSV={{
            fileName: "custom.xls",
            separator: ";",
            noAutoBOM: false,
            blobType: "text/xls;charset=ansi",
          }}
        >
          {(props) => (
            <div className="py-4">
              <UncontrolledDropdown
                group
                size="sm"
                direction="down"
                style={{ position: "absolute", top: -15, right: 30 }}
              >
                <DropdownToggle color="link">
                  <i className="fas fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem href="#">
                    <ExportCSVButton
                      {...props.csvProps}
                      style={{
                        backgroundColor: "transparent",
                        padding: 0,
                        border: 0,
                        width: "100%",
                        color: "#212529",
                        textAlign: "start",
                      }}
                    >
                      <i className="fas fa-file-export"></i>
                      <span className="ml-1">Exportar</span>
                    </ExportCSVButton>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <BootstrapTable
                {...props.baseProps}
                bootstrap4={true}
                bordered={false}
                sort={{
                  sortFunc: (a, b, order) => {
                    if (order === "asc") return a - b;
                    else return b - a;
                  },
                }}
              />
            </div>
          )}
        </ToolkitProvider>
      ) : (
        <div
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <Spinner color="primary" />
        </div>
      )}
    </>
  );
};
